import { hasDemand } from "lib/authorization/has-demand"
import { createEvent } from "library/local-events"

export const FilterRegisterHeaders = createEvent("FilterRegisterHeaders")

export function getRegisterTableHeaders() {
    const headers = [
        { id: "name", label: "Name", align: "left" },
        { id: "assetCount", label: "Assets", align: "left", canOrderBy: false },
        { id: "_modified", label: "Modified", align: "left" },
        { id: "lastModifiedBy", label: "Modified By", align: "left" },
        ...(hasDemand("syncAssetRegister")
            ? [
                  { id: "synchronise", label: "", align: "left", canOrderBy: false },
                  { id: "remove", label: "", align: "left", canOrderBy: false },
              ]
            : []),
    ]

    FilterRegisterHeaders.call({ headers })

    return headers
}
